
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jfPKi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $efb30b0835a43fa3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $efb30b0835a43fa3$export$2e2bcd8739ae039 = {
    'extension.charts.aggregateData': 'Samengevoegde gegevens',
    'extension.charts.aggregateDataDescription': "Combineer waarden in \xe9\xe9n gegevenspunt wanneer meerdere rijen dezelfde waarde hebben.",
    'extension.charts.category': 'Categorie',
    'extension.charts.customizeTab': 'Aanpassen',
    'extension.charts.dataMissing.details': 'We kunnen de brontabel van deze grafiek niet vinden op de pagina.',
    'extension.charts.dataMissing.title': 'Geen gegevens om weer te geven',
    'extension.charts.dataTab': 'Gegevens',
    'extension.charts.defaultColumnName': 'Kolom {0}',
    'extension.charts.defaultTitle': 'Naamloze grafiek',
    'extension.charts.defaultYLabel': 'As zonder titel',
    'extension.charts.extensionTitle': 'Grafiek',
    'extension.charts.height': 'Hoogte van de grafiek',
    'extension.charts.height.large': 'Hoger',
    'extension.charts.height.medium': 'Standaard',
    'extension.charts.height.small': 'Lager',
    'extension.charts.horizontal.orientation.label': 'Horizontaal',
    'extension.charts.insert.tooltip': 'Grafiek invoegen',
    'extension.charts.legend': 'Legenda',
    'extension.charts.legend.auto': 'Auto',
    'extension.charts.legend.bottom': 'Onder',
    'extension.charts.legend.left': 'Links',
    'extension.charts.legend.position': 'Positie legenda',
    'extension.charts.legend.right': 'Rechts',
    'extension.charts.legend.show': 'Legenda tonen',
    'extension.charts.legend.top': 'Boven',
    'extension.charts.options.label': 'Grafiekopties',
    'extension.charts.options.tooltip': 'Grafiekopties wijzigen',
    'extension.charts.orientation.label': "Ori\xebntatie",
    'extension.charts.seriesNames': 'Datareeksen',
    'extension.charts.showPoints': 'Gegevenspunten tonen',
    'extension.charts.smoothLines': 'Vloeiende lijnen',
    'extension.charts.style': 'Stijl',
    'extension.charts.title': 'Titel',
    'extension.charts.type.bar': 'Balk',
    'extension.charts.type.fieldDescription': 'Type grafiek',
    'extension.charts.type.line': 'Lijn',
    'extension.charts.type.pie': 'Taart',
    'extension.charts.userTitle': 'Titel',
    'extension.charts.vertical.orientation.label': 'Verticaal',
    'extension.charts.xAxis': 'X-as',
    'extension.charts.xLabel': 'Label x-as',
    'extension.charts.yLabel': 'Label Y-as'
};

});


//# sourceMappingURL=nl.39a78916.js.map
